import { Component, OnInit } from '@angular/core';
import { UIRouter } from '@uirouter/angular';
import { ProductAnalyticsService } from './Common/Analytics/productAnalytics.service';
import { NavigationService } from './Layout/navigation.service';
import { AccountService } from './User/account.service';
import { setTheme } from 'ngx-bootstrap/utils';
import { HostListener } from '@angular/core';
import { FeatureFlagsService } from './Common/FeatureFlags/feature-flags-service';
import { AuthenticationResult } from '@azure/msal-browser';
import { SettingsService } from './Common/Settings/settings.service';
import { AppStateService, AppStates } from './Layout/appStateService';
import { ScriptLoaderService, ScriptLocations } from './UI-Lib/Utilities/scriptLoader.service';
import { AceAuthOidcWrapperService } from './IAM/aceAuthOidcWrapper.service';
import { filter } from 'rxjs';
import { EasyAccessService } from './Common/Services/easyAccess.service';
import { WeissmanEnvironmentConfig } from './weissmanEnvironmentConfig';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false,
})
export class AppComponent implements OnInit {
    constructor(
        public _featureFlagsService: FeatureFlagsService,
        private readonly _accountService: AccountService,
        private readonly _settingsService: SettingsService,
        private readonly _appStateService: AppStateService,
        private readonly _scriptLoaderService: ScriptLoaderService,
        private readonly _aceAuthOidcWrapperService: AceAuthOidcWrapperService,
        private readonly _easyAccessService: EasyAccessService,
        private readonly _navigationService: NavigationService,
        private readonly _productAnalyticsService: ProductAnalyticsService,
        private readonly _router: UIRouter,
    ) {
        this.aceOidcWrapperEnabled = false;
        this.isAttachmentPopup = window.location.href.indexOf('#/attachmentPopup') >= 0;
        this._appStateService.appState$.subscribe((s) => {
            this.appState = s;
            if (s === AppStates.LoggedIn) {
                // Initialize Pendo user session
                this._productAnalyticsService.initPendo();
            }
        });
        setTheme('bs5');
    }

    aceOidcWrapperEnabled: boolean;
    isAttachmentPopup: boolean;
    appState: AppStates;

    get AppStates(): typeof AppStates {
        return AppStates;
    }

    @HostListener('window:authResponseOverride')
    handleAuthResponseOverride() {
        this._accountService.beginHomeRealmDiscovery();
    }

    @HostListener('window:authResponse', ['$event'])
    handleAuthresponse(event: Event) {
        const result = (event as CustomEvent<AuthenticationResult>).detail;
        if (
            this._featureFlagsService.featureFlags.enableIAMLogin &&
            this.appState === AppStates.Initializing &&
            result &&
            result.idToken
        ) {
            console.log('authResponse', result);
            this._accountService.loginFromAceOidc(result.idToken);
        }
    }

    async ngOnInit() {
        const windowRef = <
            {
                gmapsLoaded: () => void;
                weissmanNg1Bootstrap: () => void;
                easyAccess: EasyAccessService;
                weissmanEnvironmentConfig: WeissmanEnvironmentConfig;
            }
        >(window as any);

        windowRef.gmapsLoaded = () => {
            return null;
        };
        windowRef.easyAccess = this._easyAccessService;
        console.log('Debugging/troubleshooting tools are available on the window.easyAccess object');

        this._scriptLoaderService.loadScript(ScriptLocations.GoogleMaps, false);
        this._aceAuthOidcWrapperService.authWrapperEnabled$.pipe(filter((x) => x)).subscribe(() => {
            this.aceOidcWrapperEnabled = true;
        });

        this._router.transitionService.onStart({}, (transition) => this._navigationService.onNavStart(transition));
        await this._settingsService.Load();

        if (windowRef.weissmanEnvironmentConfig.pendoApiKey) {
            this._productAnalyticsService.injectPendo(windowRef.weissmanEnvironmentConfig.pendoApiKey);
        }

        await this._accountService.checkPersistedLogin();
        windowRef.weissmanNg1Bootstrap();
    }
}
